export default {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  baseTempImagesUrl: process.env.REACT_APP_BASE_TEMP_IMAGES_URL || 'https://alivia-media-file.s3.us-east-2.amazonaws.com',
  title: {
    minLength: 60,
    maxLength: 120,
  },
  seoTitle: {
    minLength: 60,
    maxLength: 120,
  },
  redirectTitle: {
    minLength: 60,
    maxLength: 120,
  },
  subtitle: {
    minLength: 55,
    maxLength: 140,
  },
  // TODO: hardcoded, take from media
  mediaBaseUrl: process.env.REACT_APP_MEDIA_BASE_URL || 'https://elfutbolero.com.sv',
};
